import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createFocusTrap as _createFocusTrap } from 'focus-trap';

/**
 * Creates a focus trap for the given element with the given options.
 * 
 * This function applies some default options that are different to the library.
 * Your own options still override these custom defaults:
 * 
 * ```json
 * {
     escapeDeactivates: false,
 * }
 * ```
 * 
 * @param element The element to be the focus trap, or a selector that will be used to find the element.
 * 
 * @see https://github.com/focus-trap/focus-trap#readme - Library documentation
 */
function createFocusTrap() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  args[1] = _objectSpread({
    escapeDeactivates: false
  }, args[1]);
  return _createFocusTrap(...args);
}
export * from 'focus-trap';
export { createFocusTrap };
flarum.reg.add('core', 'common/utils/focusTrap', { createFocusTrap: createFocusTrap, });